import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getCustomerGroup = createAsyncThunk(
  "admin/customer-group",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/customer-group", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getCustomerGroupById = createAsyncThunk(
  "admin/customer-group/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/customer-group/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortCustomerGroup = createAsyncThunk(
  "admin/customer-group/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/customer-group/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postCustomerGroup = createAsyncThunk(
  "admin/customer-group/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/customer-group", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteCustomerGroup = createAsyncThunk(
  "admin/customer-group/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/customer-group/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateCustomerGroup = createAsyncThunk(
  "admin/customer-group/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/customer-group/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const customerGroupSlice = createSlice({
  name: "Customer Group Store",
  initialState: initialState,
  reducers: {
    addCustomerGroup(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortCustomerGroup(state, action) {
      state.data.docs = action.payload;
    },
    deleteCustomerGroup(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editCustomerGroup(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getCustomerGroup.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getCustomerGroup.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getCustomerGroup.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getCustomerGroupById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getCustomerGroupById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getCustomerGroupById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortCustomerGroup.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortCustomerGroup.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortCustomerGroup.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postCustomerGroup.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postCustomerGroup.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postCustomerGroup.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteCustomerGroup.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteCustomerGroup.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteCustomerGroup.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateCustomerGroup.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateCustomerGroup.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateCustomerGroup.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const customerGroupActions = customerGroupSlice.actions;

export default customerGroupSlice.reducer;
